<template>
  <div>
    <JyDialog :visible.sync="visible" title="修改登录密码" max-width="450px" ref="passwordDialog">
      <el-form :model="user" :rules="rules" ref="userForm" label-width="80px" size="small" @submit.native.prevent="doSubmit">
        <el-row type="flex" class="flex-wrap">
          <form-item fill="4" label="登录账号" no-hover>
            <span class="font15">{{ userinfo.username }}</span>
          </form-item>
          <form-item fill="4" label="旧密码" prop="oldpassword" no-hover>
            <el-input type="password" v-model="user.oldpassword" :rules="rules.oldpassword" placeholder="旧密码" icon="lock"></el-input>
          </form-item>
          <form-item fill="4" label="新密码" prop="password" no-hover>
            <el-input type="password" v-model="user.password" :rules="rules.password" placeholder="新密码" icon="key"></el-input>
          </form-item>
          <form-item fill="4" label="确认密码" prop="confirmpassword" no-hover>
            <el-input type="password" v-model="user.confirmpassword" :rules="rules.confirmpassword" placeholder="确认登录密码" icon="key"></el-input>
          </form-item>
        </el-row>
        <div v-if="passwordmsg" class="text-danger text-center">{{ passwordmsg }}</div>
        <div class="login-btns mt-2 text-center">
          <JyButton type="primary" type-native="submit" icon="check-square-o" width="100%" :isLoading="isLoading" size="lg">确定更改</JyButton>
        </div>
      </el-form>
    </JyDialog>
  </div>
</template>

<script>
import CryptoJS  from 'crypto-js';
import * as types from 'jystore/mutation-types';
import tools from 'jyutils/tools';
export default {
  name: 'JyUserPassword',
  components: { },
  mixins: [tools],
  props: {

  },
  data() {
    return {
      passwordmsg: '',
      visible: false,
      isLoading: false,
      rules: {
        oldpassword: {required: true, message: '请输入旧密码！'},
        password: [{required: true, message: '请输入新密码！'}],
        confirmpassword: {required: true, equals: () => {return this.user.password}, message: '确认密码与新密码不一致！'}
      },
      user: {password:'', oldpassword:'', confirmpassword:''}
    }
  },
  watch: {
    visible() {
      this.passwordmsg = '';
    }
  },
  methods: {
    show(flag) {
      this.visible = flag ? true : false;
    },
    doSubmit() {
      this.submitform('userForm').then(() => {
        // 检查 token
        let token = this.$store.state.c_token.substr(0, 16);
        if (!token) {
          this.$store.dispatch(types.JY_TOKEN_GET);
        }

        this.passwordmsg = '';
        // 校验密码强度
        let pattern = /^.*(?=.{6,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,}).*$/;
        let isok = pattern.test(this.user.password);
        // console.log(isok)
        if (!isok) {
          this.passwordmsg = '密码强度不够，要求长度【6 - 16】个字符，包含数字及大小写字母！';
          this.$message.error(this.passwordmsg);
          this.saveLoading = false;
          return;
        }

        this.isLoading = true;
        let user = {username: this.userinfo.username, password: this.user.password, oldpassword: this.user.oldpassword};
        // Encrypt
        let key = CryptoJS.enc.Latin1.parse(token.substr(0, 16));
        let iv = CryptoJS.enc.Latin1.parse('0102030405060708');
        let oldpassword = CryptoJS.AES.encrypt(user.oldpassword, key, {iv:iv, mode:CryptoJS.mode.CBC, padding:CryptoJS.pad.Pkcs7 });
        let password = CryptoJS.AES.encrypt(user.password, key, {iv:iv, mode:CryptoJS.mode.CBC, padding:CryptoJS.pad.Pkcs7 });
        let options = {username: user.username, password: password.toString(), oldpassword: oldpassword.toString()};

        //
        this.doPost({
          url: 'sys/user/changePassword',
          data: options,
          okcb: () => {
            this.$message.success('密码修改成功！');
            this.visible = false;
          },
          cb: (json) => {
            // 如果需要更新token
            if (json.obj && json.obj.token) {
              this.$store.dispatch(types.JY_TOKEN_GET);
            }
            this.$nextTick(() => {
              this.isLoading = false;
            });
          }
        });
      })
      .catch(() => {
        
      });
    }
  }
}
</script>
